module.exports = __webpack_public_path__ + "img/tj.10e318c9.png";